import React, { useState, useEffect } from 'react';

export default function InstallButton() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsVisible(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        window.addEventListener('appinstalled', () => {
            setIsVisible(false);
            setDeferredPrompt(null);
        });

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        setDeferredPrompt(null);
        setIsVisible(false);
    };

    // Se não for para exibir, não renderiza nada
    if (!isVisible) return null;

    return (
        <div style={styles.alertContainer}>
            <div style={styles.alertContent}>
                <span style={styles.icon}>📲</span>
                <div style={styles.textContainer}>
                    <strong style={styles.title}>Instalar no Dispositivo</strong>
                    <p style={styles.description}>Acesse o dashboard mais rápido!</p>
                </div>
                <div style={styles.buttonContainer}>
                    <button onClick={() => setIsVisible(false)} style={styles.cancelButton}>
                        Agora não
                    </button>
                    <button onClick={handleInstallClick} style={styles.installButton}>
                        Instalar
                    </button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    alertContainer: {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: '#ffffff',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
        borderRadius: '12px',
        padding: '16px',
        zIndex: 9999,
        maxWidth: '360px',
        width: 'calc(100% - 40px)',
        border: '1px solid #e0e0e0',
        fontFamily: 'sans-serif'
    },
    alertContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
    },
    icon: {
        fontSize: '28px',
        alignSelf: 'center'
    },
    textContainer: {
        textAlign: 'center'
    },
    title: {
        fontSize: '16px',
        color: '#333333',
        display: 'block',
        marginBottom: '4px'
    },
    description: {
        fontSize: '13px',
        color: '#666666',
        margin: 0,
        lineHeight: '1.4'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '10px',
        marginTop: '4px'
    },
    cancelButton: {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#666666',
        fontSize: '13px',
        cursor: 'pointer',
        padding: '8px 12px'
    },
    installButton: {
        backgroundColor: '#007bff',
        color: '#ffffff',
        border: 'none',
        padding: '8px 16px',
        fontSize: '13px',
        fontWeight: 'bold',
        borderRadius: '6px',
        cursor: 'pointer',
        boxShadow: '0 2px 4px rgba(0,123,255,0.2)'
    }
};
